module.exports = __webpack_public_path__ + "static/media/icon_hero_green2get.a90150d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_hero_green2get.png
// module id = 3703
// module chunks = 0